<template>
  <div id="drawer-location-add" class="drawer drawer-right fold dw-xs-10 dw-sm-6 dw-md-6 fold" aria-labelledby="drawer-location-add" v-drawer>
    <div class="drawer-contents">
      <div class="drawer-heading">
        <h3 class="drawer-title">
          <i class="fa fa-plus"></i>
          <template v-if="editingExistingLocation">Edit Location</template>
          <template v-else>New Location</template>
          <a href="#drawer-location-add" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-shortlist" class="btn btn-primary pull-right">
            <i class="fa fa-arrow-right"></i>
          </a>
        </h3>
      </div>

      <div class="drawer-body">

        <form>
          <div class="form-group-outer">
            <div class="form-group float-label-control" :class="{ 'has-error': errors.has('name') }">
              <label for="">Property / Depot name</label>
              <input type="text" v-validate="'required'" name="name" class="form-control" placeholder="Property / Depot name" v-model="name" v-float-label>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4 col-md-3">
              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Number</label>
                  <input type="text" class="form-control" placeholder="Number" v-model="streetNumber" v-float-label>
                </div>
              </div>
            </div>
            <div class="col-sm-8 col-md-9">
              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Street Name</label>
                  <input type="text" class="form-control" placeholder="Street Name" v-model="streetName" v-float-label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Suburb / Town</label>
              <input type="text" class="form-control" placeholder="Suburb / Town" v-model="suburb" v-float-label>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="" class="select-label">State</label>
              <selectize
                v-model="state"
                name="state"
                :options="stateOptions">
              </selectize>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Postcode</label>
                  <input type="text" class="form-control" placeholder="Postcode" v-model="postcode" v-float-label>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">UHF Channel</label>
                  <input type="text" class="form-control" placeholder="UHF Channel" v-model="uhfChannel" v-float-label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Hours of loading</label>
              <input type="text" class="form-control" placeholder="Hours of loading" v-model="hoursOfLoading" v-float-label>
            </div>
          </div>

          <h2>Access Instructions</h2>

          <location-photo v-model="file" :always-editable="true">
            <ladda-button slot="delete" type="danger" :on-click="handleDeletePhoto"><i class="fa fa-trash fa-fw"></i></ladda-button>
          </location-photo>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Text Directions</label>
              <textarea class="form-control" placeholder="Text Directions" rows="5" v-model="directions" v-float-label></textarea>
            </div>
          </div>

          <h2>Location Contact</h2>

          <div class="margin-10"></div>

          <div class="form-group-outer">
            <div class="form-group">
              <div class="checkbox checkbox-primary">
                <input id="check-terms" class="styled" type="checkbox" v-model="useContactDetails">
                <label for="check-terms">
                  Use my contact details
                </label>
              </div>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Name</label>
              <input type="text" class="form-control" placeholder="Name" :class="{ 'empty' : !useContactDetails }" v-model="contactName" v-float-label>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Primary Phone</label>
                  <input type="text" class="form-control" placeholder="Primary Phone" :class="{ 'empty' : !useContactDetails }" v-model="contactPhone" v-float-label>
                </div>
              </div>
            </div>
            <div class="col-xs-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Secondary Phone (optional)</label>
                  <input type="text" class="form-control" placeholder="Secondary Phone (optional)" :class="{ 'empty' : !useContactDetails }" v-model="contactSecondPhone" v-float-label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Email Address</label>
              <input type="text" class="form-control" placeholder="Email Address" :class="{ 'empty' : !useContactDetails }" v-model="contactEmail" v-float-label>
            </div>
          </div>

          <location-map :always-editable="true"></location-map>
        </form>

      </div>
      <div class="drawer-footer">
        <ladda-button :on-click="handleSaveLocation" v-if="editingExistingLocation">
          <i class="fa fa-check"></i>
          Save Location
        </ladda-button>
        <ladda-button :on-click="handleAddNewLocation" type="primary" v-else>
          <i class="fa fa-plus"></i>
          Add New Location
        </ladda-button>
        <a href="#drawer-location-add" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-shortlist" class="btn btn-default">
          <i class="fa fa-times"></i>
          Cancel
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState, mapActions } from 'vuex'
  import { SET_LOCATION_ATTRIBUTE, RESET_LOCATION, SET_LOCATION, ADD_LOCATION } from 'vx/mutations'
  import { Selectize, LaddaButton } from 'components/forms'
  import { merge, has, cloneDeep, noop } from 'lodash'
  import { stateMapper, helpers } from 'mixins/locations'
  import { notify, alert } from 'utils'
  import LocationPhoto from 'components/locations/Photo'
  import LocationMap from 'components/locations/Map'
  import states from 'mixins/states'
  import $ from 'jquery'

  export default {
    mixins: [stateMapper, helpers, states],

    props: {
      existingLocation: {
        required: false,
        default: {}
      },
      done: {
        required: false,
        default () {
          return () => {}
        }
      },
      closed: {
        required: true,
        type: Function
      }
    },

    components: {
      Selectize,
      LaddaButton,
      LocationMap,
      LocationPhoto
    },

    data () {
      return {
        file: null,
        useContactDetails: false
      }
    },

    /**
     * On mounted we'll bind events so we can reset the location, clear errors, prefill with an
     * existing location, and alert the user that edits only apply to the job.
     *
     * @return void
     */
    mounted () {
      const show = 'show.bs.drawer'
      const shown = 'shown.bs.drawer'
      const hidden = 'hidden.bs.drawer'

      $(this.$el).on(show, this.resetStoreLocation)
       .on(show, this.clearFormErrors)
       .on(show, this.prefillWithExisting)
       .on(shown, this.alertIfEditing)
       .on(hidden, this.resetStoreLocation)
       .on(hidden, this.closed)
    },

    computed: {
      ...mapState('location', ['location']),

      /**
       * Determine if we are editing an existing location.
       *
       * @return boolean
       */
      editingExistingLocation () {
        return has(this.existingLocation, 'id')
      }
    },

    watch: {
      useContactDetails (checked) {
        if (checked) {
          this.contactName = this.$user.profile.full_name
          this.contactPhone = this.$user.mobile
          this.contactEmail = this.$user.email
        } else if (this.existingLocation) {
          this.contactName = this.existingLocation.contact_name
          this.contactPhone = this.existingLocation.contact_phone
          this.contactEmail = this.existingLocation.contact_email
        } else {
          this.contactName = null
          this.contactPhone = null
          this.contactEmail = null
        }
      }
    },

    methods: {
      ...mapActions('location', ['storeLocation', 'uploadLocationPhoto']),
      ...mapMutations('location', [SET_LOCATION_ATTRIBUTE, RESET_LOCATION, SET_LOCATION, ADD_LOCATION]),

      /**
       * Reset the store location so we have a fresh form for next time.
       *
       * @return void
       */
      resetStoreLocation () {
        this[RESET_LOCATION]()
      },

      /**
       * Clear the form errors.
       *
       * @return void
       */
      clearFormErrors () {
        this.errors.clear()
      },

      /**
       * Prefill the store location with an existing location if we are editing.
       *
       * @return void
       */
      prefillWithExisting () {
        if (this.editingExistingLocation) {
          this[SET_LOCATION](this.existingLocation)
        }
      },

      /**
       * Alert if editing a location that already exists.
       *
       * @return void
       */
      alertIfEditing () {
        if (this.editingExistingLocation) {
          setTimeout(() => {
            alert.warning({ text: 'Edits made to this location will only apply to this job.' }).catch(noop)
          }, 150)
        }
      },

      /**
       * Handle the adding of a new location.
       *
       * @return Promise
       */
      handleAddNewLocation () {
        return this.validateAll().then(() => {
          const notifyCreated = () => (notify.success('Location has been created.'))

          return this.storeLocation(this.location)
            .then(this.handleUploadPhoto)
            .then(this.addLocationToStoreState)
            .then(this.closeAndReturnLocation)
            .then(notifyCreated)
        }).catch(this.notifyWhenMissingName)
      },

      /**
       * Handle the saving of a new location.
       *
       * @return Promise
       */
      handleSaveLocation () {
        return this.validateAll().then(() => {
          const notifyUpdated = () => (notify.success('Location has been saved.'))

          let payload = merge(cloneDeep(this.location), { hidden: true })

          return this.storeLocation(payload)
            .then(this.handleUploadPhoto)
            .then(this.addLocationToStoreState)
            .then(this.closeAndReturnLocation)
            .then(notifyUpdated)
        }).catch(this.notifyWhenMissingName)
      },

      /**
       * Add the new location to the state.
       *
       * @param object response
       *
       * @return object
       */
      addLocationToStoreState (response) {
        this[ADD_LOCATION](response.data)

        return response
      },

      /**
       * Close the drawer and fire the callback to return the location.
       *
       * @return object
       */
      closeAndReturnLocation (response) {
        this.done(response.data, this.location.id)

        $(this.$el).drawer('hide')

        return response
      },

      /**
       * Notify the user when missing the name property.
       *
       * @return void
       */
      notifyWhenMissingName () {
        if (this.errors.has('name')) {
          notify.error('A location property / depot name is required.')
        }
      },

      /**
       * Handle the photo upload.
       *
       * @param object response
       *
       * @return object
       */
      handleUploadPhoto (response) {
        if (this.file) {
          return this.uploadLocationPhoto({ file: this.file, id: response.data.id }).then(response => {
            this.file = null

            return response
          })
        }

        return response
      },

      /**
       * Handle delete button for photos.
       *
       * Instead of using the default delete strategy we simply store a new location without
       * the photo path.
       *
       * @param object location
       *
       * @return Promise
       */
      handleDeletePhoto (location) {
        const photoWasDeleted = (response) => {
          this.addLocationToStoreState(response)

          this[SET_LOCATION](response.data)
        }

        let payload = merge(cloneDeep(this.location), { hidden: true, photo_path: null, photo_name: null })

        return this.storeLocation(payload).then(photoWasDeleted)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LocationDrawer.vue?73f4023b